import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { transitions } from "polished"
import { goToAnchor } from "react-scrollable-anchor"
import { FadeIn } from "animate-css-styled-components"
import { Link } from "react-router-dom"
import { compose } from "recompose"
import { injectIntl } from "react-intl"
import { FormattedMessage } from "react-intl"
import { Shadows } from "../../lib/theme"
import Box from "../../lib/ui/ui-box"
import WithScroll from "../../hocs/with-scroll.hoc"
import { getUserLanguage } from "../../utils/analytics"

import Text from "../text"
import Button from "../button"
import Logo from "../logo"

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background-image: linear-gradient(180deg, #fdfdff 0%, #fbfafe 100%);
  box-shadow: ${props =>
    props.solidBackground ? Shadows.shadowLarge : Shadows.none};
  background-color: ${props =>
    props.solidBackground ? "white" : "transparent"};
  ${transitions(
    "background-color 50ms cubic-bezier(0.68, 0, 0.265, 1)",
    "box-shadow 150ms cubic-bezier(0.68, 0, 0.265, 1)"
  )};
`

const NavigationLink = styled(Link)`
  margin-left: 16px;
`

const Navigation = ({ scrollPosition, isMobile, intl, ...restProps }) => {
  const isSolid = scrollPosition > 50
  const handleHowItWorksClick = () => {
    window.analytics.track("Clicked to Call", {
      location: "menu",
      text: "613-769-9213",
      type: "phone number"
    })
    goToAnchor("how-it-works")
  }

  return (
    <FadeIn duration="0.25s" delay="0.9s" style={{ zIndex: 10 }}>
      <Root solidBackground={isSolid}>
        <Box
          w={["80%", "80%", "80%", "1200px"]}
          flexDirection={["column", "column", "row"]}
          justify="space-between"
        >
          {!isMobile && (
            <Link
              to={intl.formatMessage({ id: "routes.home" })}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Box flexDirection="column" align="center" pl={[1]}>
                <Logo src="/logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
              </Box>
            </Link>
          )}
          <Box
            align="center"
            flexDirection={["column", "column", "row"]}
            pt={[4, 4, 0]}
          >
            <NavigationLink
              to={intl.formatMessage({ id: "routes.howitworks" })}
            >
              <Box
                pr={[0, 0, 3]}
                mb={[3, 2, 0]}
                style={{ cursor: "pointer" }}
                onClick={handleHowItWorksClick}
              >
                <Text
                  fontWeight="400"
                  fontSize={[3, 3, 1]}
                  fontFamily="Libre Baskerville"
                  color="textDarkBlue"
                >
                  <FormattedMessage
                    id="nav.how_it_works"
                    defaults="How it works"
                  />
                </Text>
              </Box>
            </NavigationLink>
            <NavigationLink
              to={intl.formatMessage({ id: "routes.faq" })}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Box pr={[0, 0, 3]} mb={[3, 2, 0]}>
                <Text
                  fontWeight="400"
                  fontSize={[3, 3, 1]}
                  fontFamily="Libre Baskerville"
                  color="textDarkBlue"
                >
                  <FormattedMessage id="nav.faq" defaults="Nesto FAQ" />
                </Text>
              </Box>
            </NavigationLink>

            <Box
              flexDirection="row"
              pr={[0, 0, 3]}
              mb={[3, 2, 0]}
              onClick={() =>
                window.analytics.track("click to call", {
                  category: "contact",
                  label: "home",
                  location: "home",
                  language: getUserLanguage()
                })
              }
            >
              <a
                href={`tel:${intl.formatMessage({
                  id: "nav.numberFormatted"
                })}`}
              >
                <Text
                  fontWeight="700"
                  fontSize={[3, 3, 1]}
                  fontFamily="Libre Baskerville"
                  color="actionPrimary"
                >
                  <FormattedMessage id="nav.number" defaults="613-769-9213" />
                </Text>
              </a>
            </Box>
            <Box pr={[0, 0, 3]} mb={[3, 2, 0]}>
              <NavigationLink
                to={intl.formatMessage({ id: "routes.get_quote" })}
              >
                <Button
                  onClick={() =>
                    window.analytics.track("get a reverse mortgage", {
                      category: "reverse mortgage flow",
                      label: "GETTING A REVERSE MORTGAGE",
                      location: "header",
                      language: getUserLanguage()
                    })
                  }
                  bg="actionPrimary"
                  align="center"
                  justify="center"
                  pl={[2, 2, 2]}
                  pr={[2, 2, 2]}
                  w={["auto", "auto", "auto"]}
                >
                  <Text
                    fontWeight="700"
                    fontSize={[2, 2, 1]}
                    fontFamily="Libre Baskerville"
                    lineHeight={["40px", "20px"]}
                    color="white"
                    alignText="center"
                  >
                    <FormattedMessage
                      id="nav.getStarted"
                      defaults="GETTING A REVERSE MORTGAGE"
                    />
                  </Text>
                </Button>
              </NavigationLink>
            </Box>
          </Box>
        </Box>
      </Root>
    </FadeIn>
  )
}

Navigation.protoTypes = {
  scrollPosition: PropTypes.number
}

export default compose(
  WithScroll,
  injectIntl
)(Navigation)



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.component.js